import { FormControl } from "baseui/form-control";
import React, { Fragment, useState } from "react";
import styled from "styled-components";
import Copy from "./Copy";
import TwoColumnGrid from "./grid/TwoColumnGrid";
import { CandidateSite } from "../models/Candidate";
import { TimePicker } from "baseui/timepicker";
import { dateFromDateArray, zonelessIsoDate } from "../utils/date";

const SiteDaysContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
	grid-column-gap: 1rem;
`;

const CandidateSites = (props: any) => {
	const DataContainer = props.showCopy ? Copy : Fragment;

	return (
		<>
			{props.candidateSites.map((candidateSite: CandidateSite) => {
				return (
					<>
						{candidateSite.siteId > 1 && <hr />}
						<TwoColumnGrid>
							<div>
								<FormControl label={`Site ${candidateSite.siteId} Name`}>
									<>
										<DataContainer>{candidateSite.jobCode ?? ""}</DataContainer>
									</>
								</FormControl>
							</div>
							<div>
								<FormControl label={`Site ${candidateSite.siteId} Hourly Rate`}>
									<>
										<DataContainer>
											${candidateSite.jobCodeRate ?? 0}
										</DataContainer>
									</>
								</FormControl>
							</div>
							<div>
								<FormControl label={`Site ${candidateSite.siteId} Reason for Custom Hourly Rate`}>
									<>
										<DataContainer>
											{candidateSite.reasonForOtherRate ?? "-"}
										</DataContainer>
									</>
								</FormControl>
							</div>
						</TwoColumnGrid>
						<div>
							<FormControl
								label={`Site ${candidateSite.siteId}  Hours per day, exclusive of meal break (total paid hours)`}
							>
								<SiteDaysContainer>
									<div>
										<FormControl label="Monday">
											<DataContainer>
												{candidateSite.mondayHours ?? 0}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Tuesday">
											<DataContainer>
												{candidateSite.tuesdayHours ?? 0}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Wednesday">
											<DataContainer>
												{candidateSite.wednesdayHours ?? 0}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Thursday">
											<DataContainer>
												{candidateSite.thursdayHours ?? 0}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Friday">
											<DataContainer>
												{candidateSite.fridayHours ?? 0}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Saturday">
											<DataContainer>
												{candidateSite.saturdayHours ?? 0}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Sunday">
											<DataContainer>
												{candidateSite.sundayHours ?? 0}
											</DataContainer>
										</FormControl>
									</div>
								</SiteDaysContainer>
							</FormControl>
						</div>

						<div>
							<FormControl
								label={`Site ${candidateSite.siteId} Start time per day.`}
							>
								<SiteDaysContainer>
									<div>
										<FormControl label="Monday Start Time">
											<DataContainer>
												 {candidateSite.mondayStartTime || ""}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Tuesday Start Time">
											<DataContainer>
												 {candidateSite.tuesdayStartTime || ""}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Wednesday Start Time">
											<DataContainer>
												 {candidateSite.wednesdayStartTime || ""}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Thursday Start Time">
											<DataContainer>
												 {candidateSite.thursdayStartTime || ""}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Friday Start Time">
											<DataContainer>
												 {candidateSite.fridayStartTime || ""}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Saturday Start Time">
											<DataContainer>
												 {candidateSite.saturdayStartTime || ""}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Sunday Start Time">
											<DataContainer>
												 {candidateSite.sundayStartTime || ""}
											</DataContainer>
										</FormControl>
									</div>
								</SiteDaysContainer>
							</FormControl>
						</div>
						<div>
							<FormControl
								label={`Site ${candidateSite.siteId} End time per day. Any shift that is longer than 4 hours must take into account a 30 minute unpaid meal break. e.g. 8:00am to 1:00pm is 4.5 hours paid.`}
							>
								<SiteDaysContainer>
									<div>
										<FormControl label="Monday End Time">
											<DataContainer>
												 {candidateSite.mondayEndTime || ""}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Tuesday End Time">
											<DataContainer>
												 {candidateSite.tuesdayEndTime || ""}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Wednesday End Time">
											<DataContainer>
												 {candidateSite.wednesdayEndTime || ""}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Thursday End Time">
											<DataContainer>
												 {candidateSite.thursdayEndTime || ""}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Friday End Time">
											<DataContainer>
												 {candidateSite.fridayEndTime || ""}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Saturday End Time">
											<DataContainer>
												 {candidateSite.saturdayEndTime || ""}
											</DataContainer>
										</FormControl>
									</div>
									<div>
										<FormControl label="Sunday End Time">
											<DataContainer>
												 {candidateSite.sundayEndTime || ""}
											</DataContainer>
										</FormControl>
									</div>
								</SiteDaysContainer>
							</FormControl>
						</div>
					</>
				);
			})}
		</>
	);
};

export default CandidateSites;
